const debug = process.env.NODE_ENV !== 'production'
window.isDebug = debug
import babelpolyfill from 'babel-polyfill'

import Vue from 'vue'
import App from './App.vue'
import store from '~script/store'

// 静态资源
import Assets from '~assets'
// 全局自定义指令
import {directive} from '~script/directive';

// 配置
import Global from '~script/global'
// 封装带过期时间的localStorage
import LocalStore from '~script/localStore'
// API接口
import Api from '~script/api'
// 全局相关业务处理
import Service from '~script/service'
// Ajax请求类
import Ajax from '~script/http'
import ViewUI from '@components/view-design';
import '~assets/css/my-theme';

import VueI18n from 'vue-i18n';
import en1 from '@components/view-design/src/locale/lang/en-US';
import zh1 from '@components/view-design/src/locale/lang/zh-CN';

import zhjson from '~script/lang/zh';
import enjson from '~script/lang/en';


import '~assets/css/common'
import '@assets/icon/index'

// 路由
import Router from 'vue-router'
import routes from './routes'

import { confirm, tips } from '~components/common/index'

Vue.use(Router)
Service.routeReset(Router)


Vue.use(confirm);
Vue.use(tips);
Vue.use(directive);
//初始化平台公共业务  
import '@scripts/initCommonService';




Vue.use(VueI18n);
Vue.use(ViewUI, {
    capture: false,
    i18n: (key, value) => i18n.t(key, value)
})

Vue.locale = () => {};


const messages = {
    'en-US': Object.assign([], enjson, en1),
    'zh-CN': Object.assign([], zhjson, zh1)
};

let locales = localStorage.getItem('locale') || navigator.language;
let locale = locales == 'zh-CN' ? 'zh-CN' : 'en-US';
localStorage.setItem('locale', locale);
// Create VueI18n instance with options
const i18n = new VueI18n({
    locale, // set locale
    messages, // set locale messages
    silentTranslationWarn: true
});

Vue.config.debug = debug
Vue.config.devtools = debug
Vue.config.productionTip = debug
Vue.prototype.$global = window.Global = Global
Vue.prototype.$api = Api
Vue.prototype.$ajax = Ajax
Vue.prototype.$assets = Assets
Vue.prototype.$localStore = window.LocalStore = LocalStore
Vue.prototype.$lt = (key) => {
    return vm.$t(key);
}
Vue.prototype.$Message.config({
    duration: 3
});

const router = new Router({
    base: Global.isPro ? "" : '',
    linkActiveClass: 'current',
    mode: 'history',
    routes,
})

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    Service.loginCheck(to, from, next); //登录状态检测
    //next();
});

window.Router = router

window.vm = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')